import { UntypedFormGroup } from '@angular/forms';

import { PerformanceMessage } from '@mitsubishi/shared/data-access';

import { StateToken } from '@ngxs/store';

import { DatasheetGroup } from '../../models';

export interface DatasheetStateModel {
  groups: DatasheetGroup[];
  messages: PerformanceMessage[];
  groupId?: number;
  sectionId?: string;
  rowKey?: string;
  form?: UntypedFormGroup;
  isEditing: boolean;
  editedValues: Record<string, unknown>;
  hasAttemptedAutoCalculation: boolean;
}

export const DATASHEET_STATE_TOKEN = new StateToken<DatasheetStateModel>('datasheet');
